import { useCallback } from 'react';

import { useListUserPaymentMethods, useSelectHasEitherCardTypes } from '@givebacks/api/core';
import { MapLocationSearch, useMap } from 'core';
import { Alert, Flex, Group, Stack, Text, Title } from 'ui';
import { AddCredentialEarnCard } from '~/pages/rewards/components/AddCredentialCard';

import { FilterModalButton } from '../FilterModal/FilterModal';

const SearchHeader = () => {
  return (
    <Group justify="space-between" wrap="nowrap">
      <Title fz={18} order={4}>
        Dining Rewards
      </Title>
      <FilterModalButton />
    </Group>
  );
};

const MissingCardAlert = () => {
  const { data: hasPartnerCard } = useSelectHasEitherCardTypes();
  const { data: hasCards } = useListUserPaymentMethods((cards) => !!cards.length);

  return (
    <Alert.Collapse in={!!(hasCards && !hasPartnerCard)} type="warning">
      <Flex gap="xs">
        <Text type="body" fw={500} flex={1}>
          Your linked card is not eligible to receive cashback.
        </Text>
        {/* TODO: Uncomment when AC's for button functionality exist */}
        {/* <ButtonMantine size="xs" variant="subtle">
      Learn More
    </ButtonMantine> */}
      </Flex>
    </Alert.Collapse>
  );
};

const EarnInStoreSearchHeader = () => {
  const { setMapCenter } = useMap();

  const handlePlaceSelect = useCallback(
    (place: google.maps.places.Place | null) => {
      if (place && place.location) {
        const lat = place.location.lat();
        const lng = place.location.lng();
        setMapCenter({ lat, lng });
      }
    },
    [setMapCenter]
  );

  return (
    <Stack>
      <SearchHeader />
      <AddCredentialEarnCard />
      <MissingCardAlert />
      <MapLocationSearch
        onPlaceSelect={handlePlaceSelect}
        formatSelectedPlace={(place) => place.formattedAddress ?? ''}
      />
    </Stack>
  );
};

export { EarnInStoreSearchHeader };
